module.exports = __webpack_public_path__ + "static/media/50012.91a75d97.png";